// extracted by mini-css-extract-plugin
module.exports = {"jp_list":"jp_list-1bM6P288"};